// @ts-strict-ignore
import React from 'react'
import i18next from 'i18next'
import { useTranslation } from 'react-i18next'
import { DataListItem } from '@node-space/ui-components'
import { ellipseMiddleText } from '@node-space/utils'
import type { PaymentMetadata } from 'types/transaction'

interface PaymentOutProps {
  amountWithCurrency: string
  paidActualAmountWithCurrency: string
  transactionReference: string
  merchantId: string
  uuid: string
  hash: string
  date: string
  sourceAddress: string
  paymentMetadata?: PaymentMetadata
  currencyFrom?: string
  currencyTo?: string
}

const PaymentOut = ({
  amountWithCurrency,
  paidActualAmountWithCurrency,
  transactionReference,
  merchantId,
  uuid,
  hash,
  date,
  sourceAddress,
  paymentMetadata,
  currencyFrom,
  currencyTo,
}: PaymentOutProps) => {
  const { t } = useTranslation()

  return (
    <>
      {amountWithCurrency && (
        <DataListItem
          id="amount-paid"
          testId="amount-paid"
          title={t('transactions.sideBar.paymentOutAmountPaid')}
          body={amountWithCurrency}
        />
      )}
      {paidActualAmountWithCurrency && (
        <DataListItem
          id="amount-received"
          testId="amount-received"
          title={t('transactions.sideBar.paymentOutAmountReceived')}
          body={paidActualAmountWithCurrency}
        />
      )}
      {merchantId && (
        <DataListItem
          id="merchant-id"
          testId="merchant-id"
          title={t('transactions.sideBar.merchantId')}
          body={merchantId}
        />
      )}
      {transactionReference && (
        <DataListItem
          id="transaction-reference"
          testId="transaction-reference"
          title={t('transactions.sideBar.reference')}
          body={ellipseMiddleText(transactionReference, 20, 10)}
          copyText={transactionReference}
        />
      )}
      {paymentMetadata?.exchangeRate && (
        <DataListItem
          id="exchange-rate"
          testId="exchange-rate"
          title={t('wallets.searchTransaction.exchangeRate')}
          body={`1 ${currencyFrom} = ${paymentMetadata?.exchangeRate} ${currencyTo}`}
        />
      )}
      {uuid && (
        <DataListItem id="uuid" testId="uuid" title={t('transactions.sideBar.uuid')} body={uuid} />
      )}
      {hash && (
        <DataListItem
          id="hash"
          testId="hash"
          title={i18next.t('hash')}
          body={ellipseMiddleText(hash, 20, 10)}
          copyText={hash}
        />
      )}
      {date && <DataListItem id="date" testId="date" title={i18next.t('date')} body={date} />}
      {sourceAddress && (
        <>
          <p className="text-h4 text-foreground-prominent mt-3">
            {t('transactions.sideBar.beneficiaryDetails')}
          </p>
          <DataListItem
            id="source-address"
            testId="source-address"
            title={t('transactions.sideBar.beneficiaryAddress')}
            body={ellipseMiddleText(sourceAddress, 20, 10)}
            copyText={sourceAddress}
          />
        </>
      )}
    </>
  )
}

export default PaymentOut
